import React from 'react';
import {
  DeviceTypes,
  DeviceTypeNames,
  TotalsByType,
  totalDevices,
} from '../../../modules/devices';
import { MessageType } from '../../../core/localization';
import Translate from '../../shared/localization/localize';

type DeviceGroupTotalType = { typeName: MessageType; total: number };
const DeviceGroupTotal: React.FC<DeviceGroupTotalType> = ({
  typeName,
  total,
}) => {
  return (
    <div className={`total_group ${total ? 'total_group_withitems' : ''}`}>
      <span className="title">
        <Translate message={typeName} />
      </span>
      <span className="value">{total}</span>
    </div>
  );
};
type DownloadTotalsType = { totals: TotalsByType };
const DownloadTotals: React.FC<DownloadTotalsType> = ({ totals }) => (
  <div className="total_section">
    <DeviceGroupTotal
      typeName={DeviceTypeNames[DeviceTypes.CONCENTRATORS]}
      total={totals.totalConcentrators}
    />
    <DeviceGroupTotal
      typeName={DeviceTypeNames[DeviceTypes.GATEWAYS]}
      total={totals.totalGateways}
    />
    <DeviceGroupTotal
      typeName={DeviceTypeNames[DeviceTypes.METERS]}
      total={totals.totalMeters}
    />
    <DeviceGroupTotal
      typeName={DeviceTypeNames[DeviceTypes.REPEATERS]}
      total={totals.totalRepeaters}
    />
    <DeviceGroupTotal
      typeName={DeviceTypeNames[DeviceTypes.VALVES]}
      total={totals.totalValves}
    />
    <hr />
    <DeviceGroupTotal typeName="Total" total={totalDevices(totals)} />
  </div>
);

export default DownloadTotals;
